import { Shield } from 'lucide-react';
import { resolveBundledClub } from './leagueClubs';

export function ClubLogo({
  club,
  className = '',
  alt,
}: {
  club?: string | null;
  className?: string;
  alt?: string;
}) {
  const identity = resolveBundledClub(club);
  if (identity) {
    return (
      <img
        className={`${className} club-logo-asset club-logo-${identity.key}`}
        src={identity.logo}
        alt={alt || identity.displayName}
        loading="lazy"
      />
    );
  }

  const monogram = (club || '')
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => part[0])
    .join('')
    .slice(0, 3)
    .toUpperCase();

  return (
    <span
      className={`club-logo-fallback club-logo-neutral ${className}`}
      aria-label={alt || club || 'Club crest unavailable'}
      title={club ? `${club} · crest unavailable` : 'Club crest unavailable'}
    >
      <Shield size={20} aria-hidden="true" />
      {monogram && <small>{monogram}</small>}
    </span>
  );
}
